import { render, staticRenderFns } from "./MobileGoHomeIcon.vue?vue&type=template&id=4e0fbda5&"
import script from "./MobileGoHomeIcon.vue?vue&type=script&lang=js&"
export * from "./MobileGoHomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports